import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {Button, Card, Col, Descriptions, Popconfirm, Row} from 'antd';
import {Shell} from '../../../components/Shell';
import {useNavigate, useParams} from 'react-router-dom';
import {AppRoutePaths} from '../../../routing/Routes';
import {EmployeeState} from '../../../store/users/employees/EmployeeState';
import {useTranslation} from 'react-i18next';
import {CardTitle, DescriptionLabel} from '../../serviceActions/utils/ServicesUtils';
import classNames from 'classnames';

export const EmployeeDisplayView: React.FC = observer((): JSX.Element => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {employeeId} = useParams();
  const [state] = useState(() => new EmployeeState());
  useEffect(() => state.loadEmployee(Number(employeeId)), [employeeId, state]);

  return (
    <Shell
      backLink
      title={
        <>
          {state.item.lastName} {state.item.firstName}
        </>
      }
      actionButtons={[
        <Button
          key="edit"
          size="large"
          className="shell-btn"
          onClick={() => navigate(`${AppRoutePaths.employees.url}/${employeeId}/edit`)}
          disabled={true}
        >
          {t('Edit employee')}
        </Button>,

        <Popconfirm
          key="delete"
          placement="bottomRight"
          title={t('Are you sure you want to remove this employee?')}
          onConfirm={() => state.deleteEmployee()}
          okText={t('Yes')}
          cancelText={t('No')}
        >
          <Button size="large" className={classNames(employeeId ? 'visible' : 'invisible')}>
            {t('Remove')}
          </Button>
        </Popconfirm>,
      ]}
    >
      <Row gutter={16}>
        <Col className="flex flex-col gap-4">
          <Card title={<CardTitle text={t('Employee data')} />}>
            <Descriptions column={2} colon={false} layout="vertical">
              <Descriptions.Item label={<DescriptionLabel text={t('employeeId')} />}>{state.item.id}</Descriptions.Item>
              <Descriptions.Item label={<DescriptionLabel text={t('Name')} />}>
                {state.item.lastName}, {state.item.firstName}
              </Descriptions.Item>
              <Descriptions.Item label={<DescriptionLabel text={t('status')} />}>
                {state.item.isActive ? 'active' : 'not active'}
              </Descriptions.Item>
              <Descriptions.Item label={<DescriptionLabel text={t('role')} />}>{state.item.userRole}</Descriptions.Item>
              <Descriptions.Item label={<DescriptionLabel text={t('phone number')} />}>
                {state.item.phoneNumberPrefix}
                {state.item.phoneNumber}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>
    </Shell>
  );
});
